import React from "react";
import {
  Switch,
  Route,
  withRouter,
  matchPath,
  RouteComponentProps
} from "react-router-dom";
import NotFound from "./404";
import PrivateRoute from "../components/private-route";
import Initialize from "../initialize";
import routes, { IRoute } from "../routes";

interface IProps extends RouteComponentProps {}

function Routes({ location }: IProps) {
  const items = routes.map((route: IRoute) => {
    if (route.isPrivate) {
      return (
        matchPath(location.pathname, {
          path: route.path,
          exact: route.exact
        }) && (
          <Initialize key={route.path}>
            <PrivateRoute
              path={route.path}
              exact={route.exact}
              Component={(props: object) => (
                <route.Layout
                  {...props}
                  layoutClass={route.layoutClass}
                  headerClass={route.headerClass}
                  containerClass={route.containerClass}
                  useOwnHeader={route.useOwnHeader}
                  pageTitle={route.pageTitle}
                  goBack={route.goBack}
                >
                  <route.Component {...props} />
                </route.Layout>
              )}
            />
          </Initialize>
        )
      );
    }

    return (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        component={(props: object) => (
          <route.Layout {...props}>
            <route.Component {...props} />
          </route.Layout>
        )}
      />
    );
  });

  return (
    <Switch>
      {items}
      <Route path="*" component={NotFound} />
    </Switch>
  );
}

export default withRouter(Routes);
